import { Hex } from '@ui-system/color';
import { Color } from '@ui-system/css';
import { U } from '@utils/ts';
import { get } from 'lodash';

import { ColorMode } from './interfaces';

export function getColorByName(
  color: U.Nullable<Color>,
  colors: ColorMode,
): Hex {
  let finalColor = color;
  if (color === 'primary' || color === 'secondary') {
    finalColor = `${color}.main` as Color;
  }
  return get(colors, finalColor as string) as Hex;
}
